namespace TabAurous.Administration {
    export interface ItemDiscountDetailsForm {
        Code: Serenity.StringEditor;
        ProductTypeId: Serenity.IntegerEditor;
        CategoryId: Serenity.IntegerEditor;
        SubCategoryId: Serenity.IntegerEditor;
        MaxDiscount: Serenity.DecimalEditor;
    }

    export class ItemDiscountDetailsForm extends Serenity.PrefixedContext {
        static formKey = 'Administration.ItemDiscountDetails';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ItemDiscountDetailsForm.init)  {
                ItemDiscountDetailsForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.DecimalEditor;

                Q.initFormType(ItemDiscountDetailsForm, [
                    'Code', w0,
                    'ProductTypeId', w1,
                    'CategoryId', w1,
                    'SubCategoryId', w1,
                    'MaxDiscount', w2
                ]);
            }
        }
    }
}
